<div class="flex-main-container">
  <div class="flex-container">
    <!-- SUBJECT -->
    <div class="flex-column field input-md">
      <lm-filter-builder-field-lookup
        id="subject"
        [qualifier]="filterRow.subject"
        [businessClass]="businessClass"
        [lookupUrl]="lookupUrl"
        [fieldSearchUrl]="fieldSearchUrl"
        [lplValidationUrl]="lplValidationUrl"
        [includeAuditFields]="includeAuditFields"
        [index]="index"
        attr.data-automation-id="lm-filter-builder-row-subject-{{rowNum}}"
        position="subject"
        mode="InstanceSelection"
        (fieldSelectionEvent)="handleFieldLookUpEvent($event, 'subject')"
      >
      </lm-filter-builder-field-lookup>
    </div>
    <ng-container>
      <!-- CONDITION -->
      <div class="flex-column field input-sm">
        <label soho-label>{{'Condition' | translate}}</label>
        <select
          soho-dropdown
          noSearch
          [attributes]="conditionAutomationId"
          [attr.id]="operatorId"
          [attr.bindId]="'bindId'"
          [readonly]="null"
          [(ngModel)]="filterRow.condition"
          (change)="onConditionChanged()"
        >
          <option *ngFor="let item of conditions" [value]="item.value">{{item.label}}</option>
        </select>
      </div>

      <ng-container *ngIf="this.hasPredicate">
        <!-- OPTIONS -->
        <div class="flex-column field input-sm">
            <label soho-label>{{'Option' | translate}}</label> <!-- needs translation -->
          <select
            soho-dropdown noSearch
            [attributes]="optionAutomationId"
            [attr.id]="literalId"
            [attr.bindId]="'bindId'"
            [readonly]="null"
            [(ngModel)]="filterRow.option"
            (change)="onOptionChanged()"
          >
            <option *ngFor="let item of options" [value]="item.value">{{item.label}}</option>
          </select>
        </div>
        <!-- PREDICATE -->
          <ng-container *ngIf="filterRow.option === 'field'">
            <!-- FIELD -->
            <div class="flex-column field input-md">
              <lm-filter-builder-field-lookup
                id="predicate"
                class="literal-input"
                [qualifier]="filterRow.predicate"
                [businessClass]="businessClass"
                [lookupUrl]="lookupUrl"
                [fieldSearchUrl]="fieldSearchUrl"
                [lplValidationUrl]="lplValidationUrl"
                [includeAuditFields]="includeAuditFields"
                [index]="index"
                attr.data-automation-id="lm-filter-builder-row-predicate-{{rowNum}}"
                position="predicate"
                mode="InstanceSelection"
                (fieldSelectionEvent)="handleFieldLookUpEvent($event, 'predicate')"
              >
            </lm-filter-builder-field-lookup>
            </div>
          </ng-container>
          <ng-container *ngIf="filterRow.option === 'custom'">
            <!-- LITERAL -->
            <ng-container *ngIf="filterRow.subject.type !== 'DATE' && filterRow.subject.type !== 'CHANGESTAMP' ">
              <!-- INPUT try to mask like only digits if a number-->
              <div class="flex-column field input-md">
                <label soho-label>{{'Value' | translate}}</label>
                <input
                  [attr.id]="literalId"
                  [attr.bindId]="filterRow.predicate"
                  [attr.type]="'text'"
                  [(ngModel)]="filterRow.predicate.text"
                  attr.data-automation-id="lm-filter-builder-row-value-{{rowNum}}"
                />
              </div>
            </ng-container>
            <ng-container *ngIf="filterRow.subject.type === 'DATE' || filterRow.subject.type === 'CHANGESTAMP' ">
              <!-- Date-->
              <div class="flex-column field input-md">
                <label soho-label>{{'Value' | translate}}</label>
                <input
                  [attr.id]="literalId"
                  class="input-sm"
                  soho-datepicker
                  [options]="datePickerOptions"
                  [(ngModel)]="filterRow.predicate.text"/>
              </div>
            </ng-container>
          </ng-container>
      </ng-container>
  </ng-container>
    <div class="flex-column field">
      <div class="label">&nbsp;</div>
      <button 
        soho-button="icon"
        (click)="onRemoveButtonEvent()"
        icon="close"
        attr.data-automation-id="lm-filter-builder-row-delete-btn-{{rowNum}}"
      ><span #LmButtonIcon class="lm-button-icon" role="presentation" aria-hidden="true"></span></button>
    </div>
  </div>
</div>

